(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons-modded"] && !Shopify.designMode) return;
  try {
    /**
   * Selling States Variant Update Handler v6
   *
   * Problem: The theme's variant picker fetches full section HTML on variant change
   * but only morphs inner elements (add-to-cart button). Our selling states can
   * completely change the DOM structure (form → link, or link → form).
   *
   * Key insight: States share DOM structures in groups:
   * - FORM group (has <product-form-component>): in_stock, preorder, backorder, forced_sold_out
   * - NO-FORM group: notify_me (link), no_buy (empty)
   *
   * Strategy:
   * - Transitions WITHIN a group (e.g. forced_sold_out → in_stock): Same DOM
   *   structure. Let the theme's built-in morph handle it. Just update data attrs.
   * - Transitions BETWEEN groups (e.g. notify_me → in_stock): Different DOM
   *   structure. Full block replacement needed.
   */
  (function() {
    const BLOCK_SELECTOR = '.buy-buttons-block--modded';

    // States that render with <product-form-component> wrapping a <form>
    var FORM_STATES = ['in_stock', 'preorder', 'backorder', 'forced_sold_out'];

    function getStructureGroup(state) {
      for (var i = 0; i < FORM_STATES.length; i++) {
        if (FORM_STATES[i] === state) return 'form';
      }
      return 'no-form';
    }

    document.addEventListener('variant:update', function(event) {
      var html = event.detail && event.detail.data && event.detail.data.html;
      if (!html) return;

      var newBlock = html.querySelector(BLOCK_SELECTOR);
      if (!newBlock) return;

      var currentBlock = document.querySelector(BLOCK_SELECTOR);
      if (!currentBlock) return;

      var currentState = currentBlock.getAttribute('data-selling-state');
      var newState = newBlock.getAttribute('data-selling-state');
      var currentGroup = getStructureGroup(currentState);
      var newGroup = getStructureGroup(newState);

      if (currentGroup !== newGroup) {
        // Crossing between DOM structure groups — full block replacement needed.
        // e.g. notify_me (link) → in_stock (form) or vice versa
        var clonedBlock = newBlock.cloneNode(true);

        setTimeout(function() {
          var block = document.querySelector(BLOCK_SELECTOR);
          if (!block) return;
          block.replaceWith(clonedBlock);
        }, 150);
      } else {
        // Same structure group — update data attributes and let theme morph handle inner content.
        // e.g. forced_sold_out → in_stock (both have product-form-component)
        for (var i = 0; i < newBlock.attributes.length; i++) {
          var attr = newBlock.attributes[i];
          currentBlock.setAttribute(attr.name, attr.value);
        }

        // After theme morph, update selling-state notes and enforce button states.
        // The theme morph only touches standard elements inside product-form-buttons.
        // Our custom selling-state-note divs live outside that container, so we
        // must manually sync them from the server-rendered HTML.
        setTimeout(function() {
          var block = document.querySelector(BLOCK_SELECTOR);
          if (!block) return;

          // Replace selling-state notes with fresh server-rendered versions
          var currentNotes = block.querySelectorAll('.selling-state-note');
          var newNotes = newBlock.querySelectorAll('.selling-state-note');

          // Remove all existing notes
          currentNotes.forEach(function(note) { note.remove(); });

          // Insert new notes in the correct positions
          var form = block.querySelector('form');
          if (form && newNotes.length > 0) {
            var formButtons = form.querySelector('.product-form-buttons');
            newNotes.forEach(function(newNote) {
              var cloned = newNote.cloneNode(true);
              // Check if this note was before or after the buttons
              // by comparing positions in the new HTML
              var newForm = newBlock.querySelector('form');
              if (newForm) {
                var newFormButtons = newForm.querySelector('.product-form-buttons');
                if (newFormButtons && newNote.compareDocumentPosition(newFormButtons) & Node.DOCUMENT_POSITION_FOLLOWING) {
                  // Note comes before buttons (position: above)
                  if (formButtons) {
                    formButtons.parentNode.insertBefore(cloned, formButtons);
                  }
                } else {
                  // Note comes after buttons (position: below)
                  if (formButtons) {
                    formButtons.parentNode.insertBefore(cloned, formButtons.nextSibling);
                  }
                }
              }
            });
          }

          // Enforce disabled state for forced_sold_out.
          var state = block.getAttribute('data-selling-state');
          var btn = block.querySelector('[ref="addToCartButton"]');
          if (btn && state === 'forced_sold_out') {
            btn.disabled = true;
          }
        }, 200);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
